import backIcon from "../../../images/arrow-left-solid.png";
import BrandLogo from "../../../common/ui/BrandLogo.js";
import * as CommonUtilities from "../../../common/utils/CommonUtils.js";

export default function CartNavigation(props) {
    return (
        <header className="shadow-sm">
            <div className="container-lg">
                <div className="row">
                    <div className="d-flex flex-row flex-wrap justify-content-start align-items-center py-2 gap-3" >
                        <BrandLogo />
                        <button type="button" className="btn btn-light rounded-pill" onClick={props.handleBackClickCart} style={{maxHeight: "max-content"}}>
                            <img src={backIcon} alt="Back" title="Back" style={{width: "20px"}}></img>
                        </button>
                    </div>
                </div>
            </div>
        </header>
    )
}